import classNames from 'classnames';
import { motion } from 'framer-motion';
import { PropsWithChildren } from 'react';
import * as svgIcons from '@progress/kendo-svg-icons';
import { useInternationalization } from '@progress/kendo-react-intl';
import { SVGIcon, SvgIcon } from '@progress/kendo-react-common';

export interface CommentActionProps extends PropsWithChildren {
  className?: string;
  votes?: number;
  status?: string | number | 'Pending' | 'Accepted' | 'Declined' | undefined;
  dueDate?: Date;
  assignee?: string;
}

export const CommentAction = ({
  className,
  votes = 0,
  status = 'Pending',
  dueDate,
  assignee = '--',
  children
}: CommentActionProps) => {
  const allIcons = svgIcons;
  const commentClass = classNames('comment', 'comment--action', className);
  let normalisedStatus =
    status?.toString() == '0' ? 'Pending' : (status as string);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, x: '50vw' }}
      className={commentClass}>
      <div className={'comment__heading'}>{children}</div>
      <CommentCard label={'Votes'} value={votes} />
      <CommentCard
        label={'Assignee'}
        value={assignee}
        icon={allIcons.userOutlineIcon}
      />
      <CommentCard label={'Status'} value={status} status={normalisedStatus} />
      <CommentCard
        label={'Due date'}
        value={dueDate}
        icon={allIcons.calendarIcon}
      />
    </motion.div>
  );
};

interface CommentCardProps {
  label: string;
  value?: string | number | Date | undefined;
  icon?: SVGIcon;
  status?: string | undefined | 'Pending' | 'Accepted' | 'Declined';
}

const CommentCard = ({ label, value, icon, status }: CommentCardProps) => {
  const intl = useInternationalization();
  const statusClass = classNames(
    { 'card__value--status': status },
    {
      pending: status == 'Pending',
      accepted: status == 'Accepted',
      declined: status == 'Declined'
    }
  );
  return (
    <div className={'comment__card'}>
      <div className={'card__label'}>{label}</div>
      <div className={'card__value'}>
        {icon && <SvgIcon icon={icon} className={'me-2'} size={'small'} />}
        <span className={statusClass}>
          {!value
            ? '--'
            : value instanceof Date
              ? intl.formatDate(value, 'd')
              : value}
        </span>
      </div>
    </div>
  );
};
